// export default {
//     AUTH_URL: 'https://auth.whaatts.com',
//     ADMIN_URL: 'https://admin.whaatts.com', //'http://api.whaatts.com',// 'https://admin.whaatts.com', //'https://admin.whaatts.com', //,//
//     BOT_URL: 'http://api.whaatts.com',
//     SEARCH_URL: 'http://localhost:3337',
//     BILLING_URL: 'http://localhost:3338',
//     PAYPAL_URL: 'https://gateway.whaatts.com'
// }

export default {
  AUTH_URL: 'https://auth.whaatts.com',
  ADMIN_URL: 'https://admin.whaatts.com', //'http://api.whaatts.com',// 'https://admin.whaatts.com', //'https://admin.whaatts.com', //,//
  BOT_URL: 'https://api.whaatts.com',
  SEARCH_URL: 'https://search.whaatts.com',
  BILLING_URL: 'https://billing.whaatts.com',
  PAYPAL_URL: 'https://gateway.whaatts.com',
  MANAGER_URL: 'https://manager.whaatts.com'
}
